import React from "react";
import { Link } from "react-router-dom";
import { User } from "lucide-react";

export default function PersonListCard({ person, familyName }) {
  const displayFamily = familyName ?? person.family_name;

  return (
    <Link
      to={`/people/${person.id}`}
      className="flex items-center gap-3 bg-white dark:bg-slate-800 px-4 py-3.5 rounded-[24px] border border-slate-200/50 dark:border-slate-700/50 shadow-card transition-all duration-300 ease-out hover:shadow-card-hover active:scale-[0.98] active:opacity-80"
    >
      <User size={18} className="text-emerald-600 dark:text-emerald-400 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-800 dark:text-slate-100 text-[14px] truncate leading-tight">
          {person.name}
        </p>
        {displayFamily && (
          <p className="text-[11px] font-medium text-emerald-600 dark:text-emerald-400 mt-0.5 truncate">
            Hogar {displayFamily}
          </p>
        )}
      </div>
    </Link>
  );
}
